// src/api/updateNotifications/updateNotificationsApi.ts

import { ENV } from '../../config/runtimeEnv';
import { getSessionUser } from "../../utils/auth/sessionUser";
import { UserUpdateNotification } from '../../types/communications/updateNotifications';
import { createServiceClient } from "../../lib/http/client";

// healthcare relays these three to admin (contract §15 rows 60–62); the browser never holds the deployment key.
export const API_BASE_URL = `${ENV.VITE_HEALTHCARE_SERVER}/admin`;

const createApiInstance = () => {
	return createServiceClient({
		baseURL: API_BASE_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const fetchUserUpdateNotifications = async (
	_includeDismissed: boolean = false
): Promise<UserUpdateNotification[]> => {
	try {
		const api = createApiInstance();
		const response = await api.get('/update-notifications');
		return response.data.data;
	} catch (error) {
		console.error('Error fetching user notifications:', error);
		throw error;
	}
};

export const markUpdateNotificationAsRead = async (notificationId: number): Promise<void> => {
	try {
		const api = createApiInstance();
		const user = getSessionUser();
		await api.post(`/update-notifications/${notificationId}/read`, {
			clinical_user_id: user.id,
		});
	} catch (error) {
		console.error('Error marking notification as read:', error);
		throw error;
	}
};

export const dismissUpdateNotification = async (notificationId: number): Promise<void> => {
	try {
		const api = createApiInstance();
		const user = getSessionUser();
		await api.post(`/update-notifications/${notificationId}/dismiss`, {
			clinical_user_id: user.id,
		});
	} catch (error) {
		console.error('Error dismissing notification:', error);
		throw error;
	}
};
